<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">二级代理商列表</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="goBack">返 回</button>
          <button class="common-bg-button" @click="search">查 询</button>
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
        </div>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入代理商名称/账号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">创建时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="createTime" @change="pickCreateTime(createTime)" range-separator="-" start-placeholder="开始时间"
                end-placeholder="结束时间" style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>

      <el-table :data="agentList" size="small" border style="width: 100%">
        <el-table-column prop="activityName" label="关联活动" min-width="140">
          <template slot-scope="{ row }">{{ row.activityName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentName" label="代理商名称" min-width="180">
          <template slot-scope="{ row }">{{ row.agentName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="账号(手机号)" min-width="130">
          <template slot-scope="{ row }">{{ row.phone || row.mobile || row.account || '-' }}</template>
        </el-table-column>
        <el-table-column prop="agentLevel" label="代理商级别" min-width="110">
          <template slot-scope="{ row }">
            <span v-if="row.agentLevel" class="level-tag level-two">{{ getAgentLevelText(row.agentLevel) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.statusEnabled" :active-value="true" :inactive-value="false"
              @change="handleStatusChange(row)" />
            <span class="status-text">{{ row.statusEnabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qrcode" label="推广二维码" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" icon="el-icon-view" @click="handleViewQrcode(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="registeredCount" label="已报名人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.registeredCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="pendingActivateCount" label="待激活人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.pendingActivateCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="usedCount" label="已使用人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.usedCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="createdWhen" label="创建时间" min-width="170">
          <template slot-scope="{ row }">{{ row.createdWhen || row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>

      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>

      <el-dialog :title="qrcodeDialogTitle" :visible.sync="qrcodeDialogVisible" width="360px" center
        @close="qrcodeDialogVisible = false; qrcodeDataUrl = ''">
        <div class="qrcode-dialog-body" v-if="currentAgent">
          <p class="agent-name">{{ currentAgent.agentName || '-' }}</p>
          <p class="agent-info-subtitle">账号: {{ currentAgent.phone || currentAgent.mobile || currentAgent.account || '-'
          }} |
            级别: {{ getAgentLevelText(currentAgent.agentLevel) }}</p>
          <div class="qrcode-placeholder">
            <img v-if="qrcodeDataUrl" :src="qrcodeDataUrl" class="qrcode-img" alt="推广二维码" />
            <i v-else class="el-icon-picture-outline" style="font-size: 120px; color: #dcdfe6;"></i>
            <p class="qrcode-tip">扫码推广</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDownloadQrcode">下载二维码</el-button>
          <el-button @click="qrcodeDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

const ACTIVITY_NO = "FREE_PILE_ACTIVITY";

export default {
  data() {
    return {
      queryInfo: { keyWord: "", startTime: "", endTime: "", pageNum: 1, pageSize: 10 },
      createTime: [],
      showMultiQuerys: false,
      agentList: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      qrcodeDialogVisible: false,
      currentAgent: null,
      qrcodeDataUrl: "",
      parentId: "",
      parentAgentName: "",
      breadCrumb: [
        { name: "营销活动" },
        { name: "送桩活动" },
        { name: "送桩代理商管理", type: "router", router: "homeChargingAgentList" },
        { name: "二级代理商列表" },
      ],
    };
  },
  computed: {
    qrcodeDialogTitle() {
      const name = this.currentAgent ? (this.currentAgent.agentName || "-") : "推广";
      return `${name} - 专属二维码`;
    },
  },
  mounted() {
    this.parentId = this.$route.query.parentId || "";
    this.parentAgentName = this.$route.query.parentAgentName || "";
    if (this.parentId) {
      this.getListData(this.pagination, true);
    } else {
      this.agentList = [];
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "homeChargingAgentList" });
    },
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);
      if (!_.parentId) {
        _.agentList = [];
        _.pagination.total = 0;
        _.$U.hideLoading(_);
        return;
      }
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        _.queryInfo.pageNum = pagination.current;
      }
      _.queryInfo.pageSize = pagination.pageSize;

      const apiUrl = _.$A.agent?.findByPage;
      if (!apiUrl) {
        _.agentList = [];
        _.pagination.total = 0;
        _.$U.hideLoading(_);
        return;
      }

      const params = {
        activityType: ACTIVITY_NO,
        agentLevel: 2,
        parentId: _.parentId,
        keyWord: _.queryInfo.keyWord || undefined,
        startTime: _.queryInfo.startTime || undefined,
        endTime: _.queryInfo.endTime || undefined,
        pageNum: (_.queryInfo.pageNum || 1) - 1,
        pageSize: _.queryInfo.pageSize || 10,
      };
      Object.keys(params).forEach((k) => params[k] === undefined && delete params[k]);

      _.$H.post(_, apiUrl, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.agentList = (Array.isArray(list) ? list : []).map((item) => ({
          ...item,
          statusEnabled: item.status === "00" || item.status === "ENABLED" || item.status === 1,
        }));
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
      }).catch(() => {
        _.agentList = [];
        _.pagination.total = 0;
      }).finally(() => {
        _.$U.hideLoading(_);
      });
    },
    pickCreateTime(time) {
      this.queryInfo.startTime = time && time[0] ? time[0] : "";
      this.queryInfo.endTime = time && time[1] ? time[1] : "";
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys;
    },
    reset() {
      this.queryInfo = { keyWord: "", startTime: "", endTime: "", pageNum: 1, pageSize: 10 };
      this.createTime = [];
      this.getListData(this.pagination, true);
    },
    search() {
      this.getListData(this.pagination, true);
    },
    handleCurrentChange(page) {
      this.pagination.current = page;
      this.getListData(this.pagination, false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.current = 1;
      this.getListData(this.pagination, true);
    },
    handleStatusChange(row) {
      const _ = this;
      const newStatus = row.statusEnabled ? "00" : "01";
      const apiUrl = _.$A.agent?.updateAgentStatus;
      if (!apiUrl) {
        _.$message.warning("状态更新接口未配置");
        row.statusEnabled = !row.statusEnabled;
        return;
      }
      _.$U.showLoading(_);
      _.$H.post(_, apiUrl, { id: row.id, status: newStatus }).then(() => {
        _.$message.success("状态更新成功");
        _.$U.hideLoading(_);
      }).catch(() => {
        row.statusEnabled = !row.statusEnabled;
        _.$U.hideLoading(_);
      });
    },
    getPromotionQrcodeUrl(phone) {
      const base = "alipays://platformapi/startapp?appId=2021003146637094&page=pages/activitiesByPopup/index&query=sharedMerchant%3D";
      return base + (phone || "");
    },
    handleViewQrcode(row) {
      this.currentAgent = row;
      this.qrcodeDataUrl = "";
      this.qrcodeDialogVisible = true;
      this.$nextTick(() => this.generateQrcode());
    },
    generateQrcode() {
      if (!this.currentAgent) return;
      const phone = this.currentAgent.phone || this.currentAgent.mobile || this.currentAgent.account || "";
      const url = this.getPromotionQrcodeUrl(phone);
      QRCode.toDataURL(url, { width: 200, margin: 2 }).then((dataUrl) => {
        this.qrcodeDataUrl = dataUrl;
      }).catch(() => {
        this.$message.error("二维码生成失败");
      });
    },
    handleDownloadQrcode() {
      if (!this.currentAgent) return;
      const phone = this.currentAgent.phone || this.currentAgent.mobile || this.currentAgent.account || "";
      const url = this.getPromotionQrcodeUrl(phone);
      const fileName = `推广二维码_${(this.currentAgent.agentName || phone || "agent").replace(/[/\\?%*:|"<>]/g, "_")}.png`;
      QRCode.toDataURL(url, { width: 300, margin: 2 }).then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = fileName;
        link.click();
        this.$message.success("二维码已下载");
      }).catch(() => {
        this.$message.error("二维码下载失败");
      });
    },
    getAgentLevelText(level) {
      const map = { "1": "一级", "2": "二级", "3": "三级", 1: "一级", 2: "二级", 3: "三级" };
      return map[level] || map[String(level)] || level || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.level-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.level-two {
    background: #f0f9eb;
    color: #67c23a;
  }
}

.status-text {
  margin-left: 8px;
  font-size: 12px;
  color: #606266;
}

.qrcode-dialog-body {
  text-align: center;
  padding: 16px 0;

  .agent-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #303133;
  }

  .agent-info-subtitle {
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
  }

  .qrcode-placeholder {
    padding: 24px;
    background: #f5f7fa;
    border-radius: 8px;

    .qrcode-img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
    }

    .qrcode-tip {
      margin-top: 12px;
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
